export enum WithdrawModalType {
    SendToken = 0,
    Dividends = 1,
    KYCBonus = 2
}